import { Button, Modal } from "@mantine/core";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import type { EnergyDataImportRequest } from "../../../EnergyData/EnergyDataUploadFlow/EnergyDataUpload";
import { EnergyDataImportDetailsTable } from "../EnergyDataImportDetailsTable/EnergyDataImportDetailsTable";
import { useDataImportRequestDetails } from "../hooks/useDataImportRequestDetails";
import { GeneralImportDetailsList } from "./GeneralImportDetailsList";

interface EnergyDataImportDetailsModalProps {
  onClose: () => void;
  dataImportRequest: EnergyDataImportRequest;
}

function EnergyDataImportDetailsModal({
  onClose,
  dataImportRequest
}: EnergyDataImportDetailsModalProps) {
  const { dataImportRequestWithDetails, isLoading, error } =
    useDataImportRequestDetails(dataImportRequest.id);

  return (
    <Modal
      opened
      size="min(80vw, 1200px)"
      title={`Importdetails: ${dataImportRequest.energyDataFile.name}`}
      onClose={onClose}
    >
      <GeneralImportDetailsList
        generalDetails={
          isLoading ? dataImportRequest : dataImportRequestWithDetails
        }
      />
      <EnergyDataImportDetailsTable
        dataImportRequestDetails={dataImportRequestWithDetails?.details}
        dataType={dataImportRequest.typeOfData}
        error={error}
        isLoading={isLoading}
      />
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Schließen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { EnergyDataImportDetailsModal };
